import axios from 'axios'
import { createI18n } from 'vue-i18n'

export const SUPPORT_LOCALES = ['en', 'es']
export type Locale = typeof SUPPORT_LOCALES[number]

export async function setLocale(locale: Locale) {
  const { global } = i18n
  if (!SUPPORT_LOCALES.includes(locale)) return

  if (!global.availableLocales.includes(locale)) {
    await loadLocale(locale);
  }

  global.locale.value = locale
  document.documentElement.lang = locale
}

async function loadLocale(locale: Locale) {
  const { global } = i18n
  const response = await axios.get(`/api/translations/online-form?lang=${locale}`)
  global.setLocaleMessage(locale, response.data);
}

export const i18n = createI18n({
  legacy: false,
  fallbackLocale: 'en'
})
